export default "__VITE_ASSET__839a2468__$_?nuxt_component=async&nuxt_component_name=SvgoFreecoins__"